import * as $ from "jquery";
import SearchControl from "vtsscheldt/HeaderParts/SearchControl"

export default class SearchPart {
    private options: any;
    private $root: JQuery;
    private searchControl: SearchControl;

    constructor() {        
        //empty
    }
    public initialize(options: any) {
        this.options = options;
        this.$root = $(options.root);
        const $searchTerm = this.$root.find('input.search-term');
        const $btnSearch = this.$root.find('.btn-search');
        this.searchControl = new SearchControl($searchTerm.data('searchUrl'), $searchTerm, $btnSearch);
        this.searchControl.initialize();
    }
    
    public destroy() {
        //empty
    }
}

